BrowsePaginationFooterPresenter = require '../../../browse/common/presenters/pagination_footer'
DealsPaginationFooterTemplate = require '../../pagination_footer.html.mustache'

module.exports = class DealsPaginationFooterView extends Backbone.View

  template: DealsPaginationFooterTemplate

  events:
    'click .pagination a': 'paginationClickHandler'

  initialize: ->
    @fetchedDealCount ?= 0
    @presenter = null

  updatePresenter: (dealSearch) ->
    page = dealSearch.page
    {number, totalPages, dealCount, nextPageSize, totalDealCount, startingIndex, endingIndex} = page
    @fetchedDealCount += dealCount

    paginationFooter = _.extend {}, BrowsePaginationFooterPresenter.toHash {
      requestURL: window.location.pathname
      query: Groupon.Utils.unparam()
      currentPageNumber: number
      totalPages
      nextPageSize: nextPageSize
      fetchedDealCount: @fetchedDealCount
      totalDealCount: totalDealCount
      startingIndex: startingIndex
      endingIndex: endingIndex
    }, undefined, {I18n}, true

    @presenter = {paginationFooter}

    this

  render: ->
    @$el.html @toHtml()

  toHtml: ->
    @template.render @presenter

  removeLoadingState: ->
    $('.pagination button').removeClass 'loading'

  paginationClickHandler: (event) =>
    event.preventDefault()
    @trigger 'click:paginationLink', event
